var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('ColorPicker',{attrs:{"id":_vm.inputId,"colorHex":_vm.inputValue,"labelText":_vm.label,"enableRgb":true},on:{"update:colorHex":function($event){_vm.inputValue = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }